import { colors as mcolors } from '@mui/material';

import { Styles } from 'shared/types';
import { colors } from 'shared/utils';

export const Table: Styles = {
  display: 'grid',
  gridTemplateColumns: '1fr auto auto',
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,

  '.MuiBox-root': {
    borderBottom: 'none',
  },
};

export const TableButtonsWrapper: Styles = {
  display: 'flex',
  gap: 1,
  alignItems: 'center',
};

export const Wrapper: Styles = {
  display: 'flex',
  borderBottom: `1px solid ${colors.lightGray}`,
  paddingLeft: '2px',
};

export const ActionInput: Styles = {
  '& .MuiInputBase-input::placeholder': {
    color: colors.slateGray,
    opacity: 1,
  },

  '& .MuiInputBase-input': {
    paddingLeft: 0,
  },

  '& .MuiOutlinedInput-root': {
    height: 51,
    fontSize: 14,
    color: colors.navy,
    borderRadius: 0,

    '& fieldset': {
      border: 'none',
    },

    '&:hover fieldset': {
      border: 'none',
    },

    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },
};

export const Checkbox: Styles = {
  height: 42,
  mr: 0.25,
  alignSelf: 'center',

  path: {
    fill: mcolors.common.black,
  },
};
